// extracted by mini-css-extract-plugin
module.exports = {"base":"Table_base__2NSS4","table":"Table_table__2OuB7","headerCell":"Table_headerCell__1nTkK","content":"Table_content__-3lq4","special":"Table_special__1HxOW"};